import React from "react";

import {
  FieldContainer,
  RadioGroup,
  RadioItem,
  SubFieldContainer,
  CheckboxGroup,
  CheckboxItem,
  CustomSelect,
  Option,
  Label,
  Note,
  Highlight,
} from "../../components/CustomFields";

import MilkHeroImage from "../../assets/images/Milk_hero.png";

import InformWarper from "./InformWarper";
import CheckboxWithImageAndQuantity from "../../components/CustomFields/CheckboxWithImageAndQuantity";

import CowMilkSImage from "../../assets/images/inform/cowMilkSImage.png";
import CowMilkMImage from "../../assets/images/inform/cowMilkMImage.png";
import CowMilkLImage from "../../assets/images/inform/cowMilkLImage.png";
import SweetCowMilkSImage from "../../assets/images/inform/sweetCowMilkSImage.png";
import SweetCowMilkMImage from "../../assets/images/inform/sweetCowMilkMImage.png";
import SweetCowMilkLImage from "../../assets/images/inform/sweetCowMilkLImage.png";
import SoyMilkSImage from "../../assets/images/inform/soyMilkSImage.png";
import SoyMilkMImage from "../../assets/images/inform/soyMilkMImage.png";
import SoyMilkLImage from "../../assets/images/inform/soyMilkLImage.png";
import SweetSoyMilkSImage from "../../assets/images/inform/sweetSoyMilkSImage.png";
import SweetSoyMilkMImage from "../../assets/images/inform/sweetSoyMilkMImage.png";
import SweetSoyMilkLImage from "../../assets/images/inform/sweetSoyMilkLImage.png";

export const quantityOptions = [
  {
    label: "1",
    value: 1,
  },
  {
    label: "2",
    value: 2,
  },
  {
    label: "3",
    value: 3,
  },
  {
    label: "4",
    value: 4,
  },
  {
    label: "5",
    value: 5,
  },
  {
    label: "มากกว่า 5",
    value: 6,
  },
];

export const noFlavoured = [
  {
    name: "freshMilkSUnit",
    label: "เล็ก",
    desc: "120-199 ml",
    image: CowMilkSImage,
    options: quantityOptions,
  },
  {
    name: "freshMilkMUnit",
    label: "กลาง",
    desc: "200-450 ml",
    image: CowMilkMImage,
    options: quantityOptions,
  },
  {
    name: "freshMilkLUnit",
    label: "ใหญ่",
    desc: "มากกว่า 450 ml",
    image: CowMilkLImage,
    options: quantityOptions,
  },
];

export const flavoured = [
  {
    name: "flavoredMilkSUnit",
    label: "เล็ก",
    desc: "120-199 ml",
    image: SweetCowMilkSImage,
    options: quantityOptions,
  },
  {
    name: "flavoredMilkMUnit",
    label: "กลาง",
    desc: "200-450 ml",
    image: SweetCowMilkMImage,
    options: quantityOptions,
  },
  {
    name: "flavoredMilkLUnit",
    label: "ใหญ่",
    desc: "มากกว่า 450 ml",
    image: SweetCowMilkLImage,
    options: quantityOptions,
  },
];

export const soyMilkNoFlavoured = [
  {
    name: "soyMilkSUnit",
    label: "เล็ก",
    desc: "120-199 ml",
    image: SoyMilkSImage,
    options: quantityOptions,
  },
  {
    name: "soyMilkMUnit",
    label: "กลาง",
    desc: "200-450 ml",
    image: SoyMilkMImage,
    options: quantityOptions,
  },
  {
    name: "soyMilkLUnit",
    label: "ใหญ่",
    desc: "มากกว่า 450 ml",
    image: SoyMilkLImage,
    options: quantityOptions,
  },
];

export const soyMilkFlavoured = [
  {
    name: "soyMilkSweetSUnit",
    label: "เล็ก",
    desc: "120-199 ml",
    image: SweetSoyMilkSImage,
    options: quantityOptions,
  },
  {
    name: "soyMilkSweetMUnit",
    label: "กลาง",
    desc: "200-450 ml",
    image: SweetSoyMilkMImage,
    options: quantityOptions,
  },
  {
    name: "soyMilkSweetLUnit",
    label: "ใหญ่",
    desc: "มากกว่า 450 ml",
    image: SweetSoyMilkLImage,
    options: quantityOptions,
  },
];

const CowMilk = ({ form = {}, setFieldsValue }) => {
  return (
    <InformWarper
      name="ดื่มดี นมวัว"
      desc="วันละ1-2กล่อง"
      icon={MilkHeroImage}
      heroLabel="Milk Hero ชวนศึกษา"
      leftButton="ดื่มดีนมวัว"
      rightButton="มาเป็น Milk Hero กันเถอะ"
      onLeftButtonClick={() => {
        window.open("/article/milk?key=read");
      }}
      onRightButtonClick={() => {
        window.open("/article/milk?key=think");
      }}
    >
      <FieldContainer
        name="haveDrunkCowMlik"
        label={
          <Label>
            เมื่อวานนี้ทั้งวัน ท่านดื่มนมวัวหรือนมถั่วเหลืองหรือไม่? (ทั้งนี้
            <b>ไม่รวม</b> นมเปรี้ยว และเครื่องดื่มที่มีนมวัวผสมลงไปบางส่วน เช่น
            เครื่องดื่มช็อกโกแล็ตใส่นม กาแฟใส่นม ชาใส่นม)
          </Label>
        }
      >
        <RadioGroup>
          <RadioItem value={false}>ไม่ได้ดื่ม</RadioItem>
          <RadioItem value={true}>ดื่ม</RadioItem>
        </RadioGroup>
      </FieldContainer>
      {form.haveDrunkCowMlik && (
        <SubFieldContainer>
          <FieldContainer
            name="noFlavoured"
            label="เมื่อวานนี้ทั้งวัน ท่านดื่มนมประเภทใด อย่างละกี่กล่อง/แก้ว/ขวด/ถุง"
          >
            <CheckboxGroup>
              <CheckboxItem value="noFlavoured" style={{ lineHeight: "32px" }}>
                นมวัว<Highlight>รสจืด</Highlight>
              </CheckboxItem>
            </CheckboxGroup>
          </FieldContainer>
          {form.noFlavoured && form.noFlavoured.includes("noFlavoured") && (
            <FieldContainer name="noFlavouredCount">
              <CheckboxGroup direction="row">
                {noFlavoured.map(({ name, label, image, desc, options }) => (
                  <CheckboxWithImageAndQuantity
                    form={form}
                    name={name}
                    label={label}
                    desc={desc}
                    image={image}
                    options={options}
                    isSelected={
                      form.noFlavouredCount &&
                      form.noFlavouredCount.includes(name)
                    }
                    groupName="noFlavouredCount"
                    selectedValues={form.noFlavouredCount}
                    setSelectedValues={setFieldsValue}
                  />
                ))}
              </CheckboxGroup>
            </FieldContainer>
          )}
          <FieldContainer name="flavoured">
            <CheckboxGroup>
              <CheckboxItem value="flavoured" style={{ lineHeight: "32px" }}>
                นมวัว<Highlight>ปรุงแต่งรส</Highlight>
                <br />
                <Label>เช่น นมรสช็อคโกแลต, นมรสหวาน, นมรสกล้วย เป็นต้น</Label>
              </CheckboxItem>
            </CheckboxGroup>
          </FieldContainer>
          {form.flavoured && form.flavoured.includes("flavoured") && (
            <FieldContainer name="flavouredCount">
              <CheckboxGroup direction="row">
                {flavoured.map(({ name, label, image, desc, options }) => (
                  <CheckboxWithImageAndQuantity
                    form={form}
                    name={name}
                    label={label}
                    desc={desc}
                    image={image}
                    options={options}
                    isSelected={
                      form.flavouredCount && form.flavouredCount.includes(name)
                    }
                    groupName="flavouredCount"
                    selectedValues={form.flavouredCount}
                    setSelectedValues={setFieldsValue}
                  />
                ))}
              </CheckboxGroup>
            </FieldContainer>
          )}
          <FieldContainer name="soyMilkNoFlavoured">
            <CheckboxGroup>
              <CheckboxItem
                value="soyMilkNoFlavoured"
                style={{ lineHeight: "32px" }}
              >
                นมวัวถั่วเหลือง<Highlight>รสจืด</Highlight>
              </CheckboxItem>
            </CheckboxGroup>
          </FieldContainer>
          {form.soyMilkNoFlavoured &&
            form.soyMilkNoFlavoured.includes("soyMilkNoFlavoured") && (
              <FieldContainer name="soyMilkNoFlavouredCount">
                <CheckboxGroup direction="row">
                  {soyMilkNoFlavoured.map(
                    ({ name, label, image, desc, options }) => (
                      <CheckboxWithImageAndQuantity
                        form={form}
                        name={name}
                        label={label}
                        desc={desc}
                        image={image}
                        options={options}
                        isSelected={
                          form.soyMilkNoFlavouredCount &&
                          form.soyMilkNoFlavouredCount.includes(name)
                        }
                        groupName="soyMilkNoFlavouredCount"
                        selectedValues={form.soyMilkNoFlavouredCount}
                        setSelectedValues={setFieldsValue}
                      />
                    )
                  )}
                </CheckboxGroup>
              </FieldContainer>
            )}
          <FieldContainer name="soyMilkFlavoured">
            <CheckboxGroup>
              <CheckboxItem
                value="soyMilkFlavoured"
                style={{ lineHeight: "32px" }}
              >
                นมวัวถั่วเหลือง<Highlight>รสหวาน</Highlight>
              </CheckboxItem>
            </CheckboxGroup>
          </FieldContainer>
          {form.soyMilkFlavoured &&
            form.soyMilkFlavoured.includes("soyMilkFlavoured") && (
              <FieldContainer name="soyMilkFlavouredCount">
                <CheckboxGroup direction="row">
                  {soyMilkFlavoured.map(
                    ({ name, label, image, desc, options }) => (
                      <CheckboxWithImageAndQuantity
                        form={form}
                        name={name}
                        label={label}
                        desc={desc}
                        image={image}
                        options={options}
                        isSelected={
                          form.soyMilkFlavouredCount &&
                          form.soyMilkFlavouredCount.includes(name)
                        }
                        groupName="soyMilkFlavouredCount"
                        selectedValues={form.soyMilkFlavouredCount}
                        setSelectedValues={setFieldsValue}
                      />
                    )
                  )}
                </CheckboxGroup>
              </FieldContainer>
            )}
        </SubFieldContainer>
      )}
    </InformWarper>
  );
};

export default CowMilk;
